import React, { Component } from 'react';

class RequiredSpan extends Component {
  render() {
    const style = {
      'display': this.props.hidden ? 'none' : 'inline'
    };

    return (
      <span className="form-required"
            title={this.props.title}
            style={style}></span>
    );
  }
}

RequiredSpan.defaultProps = {
  title: 'This field is required.'
};

export default RequiredSpan;
